import { render } from "./FugleTable.vue?vue&type=template&id=0b3b5516&scoped=true&ts=true"
import script from "./FugleTable.vue?vue&type=script&lang=ts"
export * from "./FugleTable.vue?vue&type=script&lang=ts"

import "./FugleTable.vue?vue&type=style&index=0&id=0b3b5516&lang=scss&scoped=true"
import "./FugleTable.vue?vue&type=style&index=1&id=0b3b5516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3b5516"]])

export default __exports__